export enum FeatureToggle {
  ScanAndPay = 'rt_scan_and_pay_retailers',
  ScanAndPayOrderRefund = 'rt_scan_and_pay_order_refund',
  LegacyOrdersRestrictedAccess = 'rt_legacy_orders_restricted_access',
  LegacyOrdersCareToolsClient = 'rt_legacy_orders_caretools_client',
  LegacyOrdersModernUi = 'rt_legacy_orders_modern_ui',
  LegacyOrdersModernEnabled = 'rt_legacy_orders_modern_enabled',
}
